import { useState } from 'react';
import { useModalA11y } from '../../hooks/useModalA11y.js';

const REASONS = [
  { key: 'doutrina_incorreta', label: 'Doutrina incorreta ou imprecisa' },
  { key: 'ofensivo', label: 'Conteúdo ofensivo ou desrespeitoso' },
  { key: 'conteudo_perigoso', label: 'Conteúdo perigoso ou prejudicial' },
  { key: 'outro', label: 'Outro motivo' },
];

export default function ReportMessageModal({ onSubmit, onCancel, submitting }) {
  const [reason, setReason] = useState('');
  const modalA11y = useModalA11y(true, onCancel, 'report-title');

  const handleSubmit = () => {
    if (!reason || submitting) return;
    onSubmit(reason);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in">
      <div {...modalA11y} className="bg-surface-container-high border border-outline-variant/30 max-w-sm w-full rounded-2xl p-6 shadow-2xl flex flex-col space-y-4 animate-scale-up text-on-surface">
        <h2 id="report-title" className="font-serif text-lg font-bold">Reportar esta resposta</h2>
        <p className="text-xs text-on-surface-variant leading-relaxed">
          Sua denúncia é enviada para revisão da equipe do CatholicGPT.
        </p>

        <div className="flex flex-col gap-2">
          {REASONS.map((r) => (
            <label
              key={r.key}
              className={`flex items-center gap-2 p-2.5 rounded-xl border cursor-pointer text-sm transition-colors min-h-[44px] ${reason === r.key ? 'border-primary bg-primary/10' : 'border-outline-variant/20 hover:border-outline-variant/40'}`}
            >
              <input
                type="radio"
                name="report-reason"
                value={r.key}
                checked={reason === r.key}
                onChange={() => setReason(r.key)}
                className="accent-primary"
              />
              {r.label}
            </label>
          ))}
        </div>

        <div className="flex flex-col gap-2 pt-2">
          <button
            onClick={handleSubmit}
            disabled={!reason || submitting}
            className="w-full min-h-[44px] py-2.5 bg-primary text-on-primary font-bold rounded-xl shadow-lg hover:opacity-95 active:scale-[0.98] transition-all disabled:opacity-50"
          >
            {submitting ? 'Enviando...' : 'Enviar denúncia'}
          </button>
          <button
            onClick={onCancel}
            disabled={submitting}
            className="text-xs text-on-surface-variant hover:text-primary transition-colors font-medium underline block mx-auto pt-1 min-h-[44px]"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
